import moment, { Moment } from 'moment'

import { formatBackendDateRange } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const getEndOnDate = (date: Moment, useYesterday: boolean) => {
  const today = moment()

  if (date.isSame(today, 'month')) {
    return useYesterday
      ? today.clone().subtract(1, 'days').format('YYYY-MM-DD')
      : today.format('YYYY-MM-DD')
  } else {
    return date.endOf('month').format('YYYY-MM-DD')
  }
}

export const getDateRange = (date: Moment) => {
  const startOn = date.clone().startOf('month').format('YYYY-MM-DD')
  const endOn = getEndOnDate(date.clone(), false)
  const endOnOrYesterday = getEndOnDate(date.clone(), true)
  const endOfMonth = date.clone().endOf('month').format('YYYY-MM-DD')

  return { startOn, endOn, endOnOrYesterday, endOfMonth }
}

export const formatDateRangeCopy = (startOn: string, endOn: string) => {
  const today = moment().format('YYYY-MM-DD')
  const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')

  if (!moment(startOn, 'YYYY-MM-DD').isValid()) {
    return i18n.t('clock_in.sidepanel.balance.no_data_yet')
  }

  if (startOn === today && endOn === today) {
    return i18n.t('common.today')
  }

  if (startOn === yesterday && endOn === yesterday) {
    return i18n.t('common.yesterday')
  }

  if (endOn === today) {
    return `${moment(startOn).format('D MMM, YYYY')} - ${i18n.t('common.today')}`
  }

  if (endOn === yesterday) {
    return `${moment(startOn).format('D MMM, YYYY')} - ${i18n.t('common.yesterday')}`
  }

  return formatBackendDateRange(startOn, endOn)
}
